import ScrollFunc from '../views/components/scrollFunc.es6';
import TopController from '../controllers/topController.es6';

export default class Main {
    constructor() {}

    async init() {
        this.TopController = new TopController();
        await this.TopController.setContent();
    }
}

const main = () => {
    // CHANGED: 実行場所変更、更にグローバルで使えるように
    const scrollFunc = new ScrollFunc();
    window.COMMON = {
        scrollFunc: scrollFunc,
    };

    const router = new Main();
    router.init();
};

// HTML内でコンテンツよりjsの読み込みが先なので、Domがロードされてから実行する
window.addEventListener('DOMContentLoaded', () => {
    main();
});
